import agentProfileDictionary from '@entities/agent-profile/i18n/ru/agent-profile.dic.json';

export const agentProfile = {
  AGENT_PROFILE: agentProfileDictionary,
};

export const agentProfileNamespaces = ['AGENT_PROFILE'];
